import styled from "styled-components"
import FeatureBlock from "..//FeatureBlock"
import Colors from "../../theme/colors"
import Button from "../base/Button"
import Box from "../base/Box"
import { media } from "../../theme/mediaQuery"

export const FeatureContainer = styled(Box)`
  .boxServiceContainer {
    display: flex;
    justify-content: center;
  }

  .myService {
    flex-wrap: wrap;
    justify-content: center;
    ${media.down("md")} {
      width: 100%;
    }
    width: 25vw;
  }
`
export const FeatureItem = styled(FeatureBlock)`
  position: relative;
  padding: 50px 30px;
  border: 1px solid #f2f4f7;
  border-radius: 5px;
  background-color: #fff;
  transition: 0.35s ease-in-out;
  height: auto;

  ${media.up("lg")} {
    height: 450px;
  }

  @media (max-width: 768px) and (min-width: 768px) {
    padding: 30px 20px;
  }
  @media (max-width: 575px) {
    padding: 40px 25px;
  }

  &:before {
    content: "";
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    opacity: 0;
    // background: linear-gradient(
    //   29deg,
    //   rgb(255, 148, 147) 0%,
    //   rgb(255, 120, 162) 100%
    // );
    transition: 0.35s ease-in-out;
  }

  & > div {
    position: relative;
  }

  h2,
  p {
    transition: 0.35s ease-in-out;
  }

  .hover-shape {
    width: 20px;
    height: auto;
    position: absolute;
    z-index: 1;
    opacity: 0;
    pointer-events: none;
    transition: 0.6s cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: rotate(260deg);
  }

  .hover-shape-1 {
    left: 0;
    top: 20px;
  }

  .hover-shape-2 {
    right: 29%;
    top: 0;
  }

  .hover-shape-3 {
    right: 0;
    bottom: 35%;
  }

  .hover-shape-4 {
    right: 30%;
    bottom: 0;
  }

  .hover-shape-5 {
    left: 0;
    bottom: 30%;
  }

  .icon__wrapper {
    margin-bottom: 40px;
    @media (max-width: 768px) and (min-width: 768px) {
      margin-bottom: 30px;
    }
    @media (max-width: 575px) {
      margin-bottom: 25px;
    }
    i {
      text-transform: lowercase;
      line-height: 1;
      font-size: 65px;
      transition: 0.35s ease-in-out;
      @media (max-width: 768px) and (min-width: 768px) {
        font-size: 50px;
      }
      &.violate {
        color: ${Colors.logo};
      }
      &.yellow {
        color: ${Colors.tertiary};
      }
      &.green {
        color: ${Colors.secondaryLight};
      }
    }
  }

  .button__wrapper {
    a {
      color: #c2cbd6;
      font-size: 24px;
      transition: 0.35s ease-in-out;
      @media (max-width: 768px) and (min-width: 768px) {
        font-size: 20px;
      }
      @media (max-width: 575px) {
        font-size: 22px;
      }
    }
  }

  @keyframes my-shape-opacity-anim {
    0% {
      opacity: 0.9;
    }
    25% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    75% {
      opacity: 0.2;
    }
    100% {
      opacity: 0.1;
    }
  }

  &:hover {
    background-image: linear-gradient(
      29deg,
      rgb(255, 148, 147) 0%,
      rgb(255, 120, 162) 100%
    );
    &:before {
      opacity: 0.37;
    }

    .hover-shape-1 {
      left: -40px;
      top: 20px;
    }
    .hover-shape-2 {
      right: 29%;
      top: -47px;
    }
    .hover-shape-3 {
      right: -27px;
      bottom: 35%;
    }
    .hover-shape-4 {
      right: 30%;
      bottom: -60px;
    }
    .hover-shape-5 {
      left: -35px;
      bottom: 30%;
    }
    .hover-shape {
      transform: rotate(0);
      // opacity: 1;
      animation: my-shape-opacity-anim 1.5s;
    }

    h2,
    p {
      color: #fff;
    }

    .icon__wrapper {
      i {
        color: #fff;
      }
    }
    i {
      .green {
        color: white;
      }
    }

    .button__wrapper {
      a {
        color: #fff;
      }
    }
  }
`

export const FeatureButton = styled(Button)`
  background: none;
  color: ${Colors.secondGradStart};

  ${FeatureItem}:hover & {
    color: white;
    transform: scale(1.2);
  }
`
